var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKeyability(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1755478212107,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 13275,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M512 32l480 364.8L809.6 992H214.4L32 396.8 512 32z m0 139.2L156.8 444.8l134.4 441.6h441.6l134.4-441.6L512 171.2z",
    fill: "#ffffff",
    "p-id": 13276
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M512 320l225.6 168-86.4 278.4H372.8L286.4 488z",
    fill: "#ffffff",
    "p-id": 13277
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyability);
export default __webpack_public_path__ + "static/media/keyability.db4012fb.svg";
export { ForwardRef as ReactComponent };